import type { User } from '@supabase/supabase-js';

const INITIALS_LENGTH = 2;

export function getInitials(user: User): string {
  const { first_name, last_name } = user.user_metadata ?? {};
  if (first_name && last_name) {
    return (first_name[0] + last_name[0]).toUpperCase();
  }
  return (user.email ?? '').substring(0, INITIALS_LENGTH).toUpperCase();
}
